import React from "react";
import { StyledMainBox, StyledRightAlignedStack } from "../../components/commonComponents/StyledComponents/styled";
import { useNavigate, useParams } from "react-router-dom";
import AccessControl from "../../components/commonComponents/Hoc/AccessControl";
import { fetchCampaign } from "../../api_calls/campaignRequests";
import ActionButton, {
  ConditionalOutlinedButton,
  LightGreyButton,
} from "../../components/commonComponents/Buttons/ActionButton";
import { useDispatch, useSelector } from "react-redux";
import { updateStateData } from "../../Store/actions";
import BrandReportFilter from "./ModalContent/BrandReportFilter";
import AnalyticsDashboard from "./Reports/AnalyticsDashboard";
import { fetchReportTabsConfigForPublishedReport } from "../../api_calls/ReportSettings";

const BrandReportView = () => {
  const dispatchAction = useDispatch();
  const campaignDetails = useSelector((state) => state.userSelections);
  const { id } = useParams();
  const navigate = useNavigate();
  const reportTabsConfig = typeof campaignDetails.campaign_detail !== "undefined" && typeof campaignDetails.brand_filters !== "undefined" ? fetchReportTabsConfigForPublishedReport("Brand") : [];

  React.useEffect(() => {
    dispatchAction(
      updateStateData({
        brand_report_view: true,
      })
    );
    fetchCampaign(id, "all", "Brand");
  }, []);

  return (
    <StyledMainBox component="main">
      {typeof campaignDetails.campaign_detail !== "undefined" && typeof campaignDetails.brand_filters !== "undefined" && reportTabsConfig.length !== 0 && (
        <>
          <AnalyticsDashboard
            reportSettingArr={reportTabsConfig}
            viewMode={"Brand"}
            preview={false} />
        </>
      )}
    </StyledMainBox>
  );
};

export default AccessControl(BrandReportView, [
  "campaign_reports_performance_can_view",
  "campaign_reports_impression_can_view",
], [], ["campaigns_section", "campaign_list"]);
